import React from "react";
import { Button, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();
    const goHome = () =>{
        navigate('/login')
    }
  return (
    <>
      <div
        style={{
          backgroundColor: "#00B1FF",
          backgroundImage: "url(https://cdn.deelfietsnederland.nl/assets/dashboard/login_background.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "50%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container>
          <Card>
            <Card.Header className="bg-warning">
              <h1>404!</h1>
            </Card.Header>
            <Card.Body>Your page is not found</Card.Body>
            <Card.Footer>
                <Button variant="link" onClick={goHome}>
                    Go home!
                </Button>
            </Card.Footer>
          </Card>
        </Container>
      </div>
    </>
  );
};
export default NotFound;
